module.exports = __webpack_public_path__ + "static/media/kjri_maps.2540efeb.png";